module.exports = __webpack_public_path__ + "img/flb.18448b42.png";